import { getRequest, postRequest } from "../services/apiHelpers";

export const getLangResources = async (params) => {
  try {
    const res = await getRequest({ url: "languages", query: params });
    return res;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const postLangResource = async (payload) => {
  try {
    const res = await postRequest({ url: "languages", payload: payload });
    return res;
  } catch (error) {
    throw new Error(error.message);
  }
};
